import { defineMessage } from 'services/localization';

export const messages = {
    endStepBubbleTextPo: defineMessage('creation_in_quickbooks'),
    endStepDescriptionPo: defineMessage('pluraltemplatename_will_ine_upon_final_approval'),
};
